<template>
    <div class="content-body">
        <div class="left-list">
            <div class="left-list-title">
                <div class="color-block"></div>
                <div class="title">栏目</div>
                <div class="color-block end"></div>
            </div>
            <div class="left-list-content">
                <div class="block"></div>
                <div class="splitter"></div>
                <div class="list-content">
                    <div class="content">
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(1)">什么是白色污染</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(2)">白色污染主要有哪些成分</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(3)">白色污染严重性</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(4)">白色污染的防治与对策</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(5)">提倡使用环保塑料袋（视频）</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <WhatIsWhitePollutionView v-if="openIndex == 1"/>
        <WhatMadeWhitePollutionView v-if="openIndex == 2"/>
        <HarmForWhitePollutionView v-if="openIndex == 3"/>
        <WhitePollutionPreventAndDo v-if="openIndex == 4"/>
        <EnvPreventRecommendView v-if="openIndex == 5"/>
    </div>
</template>

<script>
    import WhatIsWhitePollutionView from "./WhatIsWhitePollutionView";
    import WhatMadeWhitePollutionView from "./WhatMadeWhitePollutionView";
    import HarmForWhitePollutionView from "./HarmForWhitePollutionView";
    import EnvPreventRecommendView from "./EnvPreventRecommendView";
    import WhitePollutionPreventAndDo from "./PreventAndDo/IndexView";
    export default {
        name: "Index",
        components: {WhatIsWhitePollutionView, WhatMadeWhitePollutionView, HarmForWhitePollutionView, WhitePollutionPreventAndDo, EnvPreventRecommendView},
        data() {
            return {
                openIndex: 1
            }
        },
        methods: {
            openPage: function (index) {
                this.openIndex = index
            }
        }
    }
</script>

<style lang="scss" src="../../assets/scss/menu.scss" scoped />
<style lang="scss" scoped>

    .list-content {
        width: 80%;
        margin-left: 10%;
        maring-top: 22px;
        .content {
            p {
                line-height: 16px !important;
                padding-top: 22px;
            }
        }
    }
</style>